import React, { useState } from 'react'
import { HelpCircle, MessageSquare } from 'lucide-react'
import SupportForm from './SupportForm'
import { usePermissions } from '../../hooks/usePermissions'
import { useAuth } from '../../context/AuthContext'
import { apiService } from '../../services/api'

const HelpButton = ({ variant = 'floating', className = '' }) => {
  const [showSupportForm, setShowSupportForm] = useState(false)
  const { hasPermission } = usePermissions()
  const { user } = useAuth()

  // Check if user has permission to access support
  const canAccessSupport = user?.role === 'admin' || hasPermission('can_access_support')

  const handleSupportSubmit = async (formData) => {
    try {
      console.log('Submitting support request with data:', formData)

      const response = await apiService.post('/support', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      console.log('Support request submitted:', response.data)
      return response.data
    } catch (error) {
      console.error('Support submission error:', error)
      console.error('Error response data:', error.response?.data)
      console.error('Error status:', error.response?.status)
      throw error
    }
  }

  // Don't render if user doesn't have permission
  if (!canAccessSupport) {
    return null
  }

  if (variant === 'floating') {
    return (
      <>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <button
            onClick={() => setShowSupportForm(true)}
            className="btn btn-primary"
            title="Need Help?"
            style={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 40,
              width: 56,
              height: 56,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
            }}
          >
            <HelpCircle style={{ width: 24, height: 24 }} />
          </button>
        </div>

        <SupportForm
          isOpen={showSupportForm}
          onClose={() => setShowSupportForm(false)}
          onSubmit={handleSupportSubmit}
        />
      </>
    )
  }

  if (variant === 'button') {
    return (
      <>
        <button
          onClick={() => setShowSupportForm(true)}
          className="btn btn-ghost"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 13 }}
        >
          <MessageSquare style={{ width: 16, height: 16 }} />
          Need Help?
        </button>

        <SupportForm
          isOpen={showSupportForm}
          onClose={() => setShowSupportForm(false)}
          onSubmit={handleSupportSubmit}
        />
      </>
    )
  }

  if (variant === 'icon') {
    return (
      <>
        <button
          onClick={() => setShowSupportForm(true)}
          className="btn btn-ghost btn-icon"
          title="Need Help?"
        >
          <HelpCircle style={{ width: 20, height: 20 }} />
        </button>

        <SupportForm
          isOpen={showSupportForm}
          onClose={() => setShowSupportForm(false)}
          onSubmit={handleSupportSubmit}
        />
      </>
    )
  }

  return null
}

export default HelpButton
